import {
  isWorkbookValueListOperator,
  workbookFilterSchema,
  type WorkbookColumnarSheet,
} from '@erp/shared-types';

type Filter = WorkbookColumnarSheet['filters'][number];
type FilterOperator = Filter['operator'];

const VALUELESS: ReadonlySet<FilterOperator> = new Set([
  'is-null',
  'is-not-null',
  'is-error',
  'is-not-error',
  'is-na',
  'is-one-of',
  'is-not-one-of',
]);

/** Whether a filter operator compares against one value; Is Empty, the error filters and Value list filters don't. */
export function filterTakesValue(operator: FilterOperator): boolean {
  return !VALUELESS.has(operator);
}

/** The operators a condition filter picks from: all but the Value list filters', which the value list edits. */
export const CONDITION_OPERATORS: readonly FilterOperator[] =
  workbookFilterSchema.shape.operator.options.filter(
    (operator) => !isWorkbookValueListOperator(operator),
  );

/** How many of a Value list filter's values a summary names before "and N more". */
const SUMMARY_VALUES = 3;

/**
 * A Value list filter's values for a summary: the first few, the Empty entry
 * as `emptyLabel`, and how many more there are.
 */
export function filterValuesSummary(
  filter: Filter,
  emptyLabel: string,
): { shown: string; more: number } {
  const values = filter.values ?? [];
  return {
    shown: values
      .slice(0, SUMMARY_VALUES)
      .map((value) => (value === '' ? emptyLabel : value))
      .join(', '),
    more: Math.max(0, values.length - SUMMARY_VALUES),
  };
}
